import { Component } from 'react';
import { connect } from 'react-redux';
import { Outlet, useNavigate } from 'react-router';
import * as globalActions from '../../actions/global';
import footerImage from '../../assets/images/house-tops-bg.jpg';
import footerImageLoading from '../../assets/images/updating-properties.gif';
import LoginModal from '../_components/loginModal';
import Logout from '../_components/logout';
import Toast from '../_components/toast';
import selector from './selector';
import '../../main.scss';
import './index.scss';

export const TOKEN_REFRESH_INTERVAL_MS = 270000;

class App extends Component {
  constructor(props) {
    super(props);
    this.gtagInjected = false;
  }

  componentDidMount() {
    this.initToken();
  }

  componentWillUnmount() {
    clearTimeout(this.tokenRefreshTimer);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token) {
      this.props.fetchClientConfig().catch(() => {
        this.props.navigate('/maintenance');
      });
    }
    const { config } = this.props;
    if (config !== prevProps.config) {
      const configJs = config?.get('data')?.toJS() || {};
      if (
        configJs.useGoogleAnalytics &&
        configJs.googleAnalyticsID?.length &&
        !this.gtagInjected
      ) {
        const gaId = configJs.googleAnalyticsID;
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(gtagScript);
        const inline = document.createElement('script');
        inline.text = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${gaId.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}');
                `;
        document.head.appendChild(inline);
        this.gtagInjected = true;
      }
    }
  }

  initToken() {
    const { fetchToken, office } = this.props;
    fetchToken(office);
    this.tokenRefreshTimer = setTimeout(
      () => this.initToken(),
      TOKEN_REFRESH_INTERVAL_MS,
    );
  }

  render() {
    const { token, config, user, importStatus } = this.props;
    const configJs = config?.get('data')?.toJS() || {};
    const importStatusJs = importStatus?.get('data');

    return (
      <div className='wrap-container'>
        {user && Boolean(Object.keys(user).length) && <Logout />}
        <main>
          {token ? (
            <Outlet />
          ) : (
            <div className='example-loading example-well h-150 vertical-align text-center'>
              <div className='loader vertical-align-middle loader-round-circle' />
            </div>
          )}
        </main>
        <div className='footer-image-container'>
          <img
            alt=''
            src={
              importStatusJs === 'In Progress'
                ? footerImageLoading
                : footerImage
            }
          />
          <div className='footer'>
            <div>
              <span>{configJs.footerMessage}</span>
            </div>
            <div>
              <span style={{ marginRight: '5px' }}>Powered by: &#32;</span>
              <span>
                {' '}
                &#60;<a href='http://trueprodigy.com/'>True Prodigy</a>&#62;
              </span>
            </div>
          </div>
        </div>
        <LoginModal config={configJs} />
        <Toast />
      </div>
    );
  }
}

const ConnectedApp = connect(selector, {
  fetchToken: globalActions.fetchToken,
  fetchClientConfig: globalActions.fetchClientConfig,
  logout: globalActions.logout,
})(App);

// Functional wrapper to inject useNavigate into the class component
// (withRouter was removed in react-router-dom v6)
const AppWithRouter = (props) => {
  const navigate = useNavigate();
  return <ConnectedApp {...props} navigate={navigate} />;
};

export default AppWithRouter;
